var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppContext } from '../contexts/AppContextProvider';
import sanitizeHTML from '../utils/sanitizeHTML';
import { Bubble, Form } from '../components';
export var RobotMessage = function () {
    var _a = useAppContext(), appConfig = _a.appConfig, activeStep = _a.activeStep, handleActiveStep = _a.handleActiveStep, successMessage = _a.successMessage;
    var formConfig;
    if (activeStep !== 'submitted') {
        formConfig = appConfig.forms[activeStep];
        if (!formConfig) {
            handleActiveStep('navigation');
            return null;
        }
    }
    return (_jsx(Bubble, { children: activeStep !== 'submitted' ? (_jsxs(_Fragment, { children: [_jsx("div", { dangerouslySetInnerHTML: { __html: sanitizeHTML((formConfig === null || formConfig === void 0 ? void 0 : formConfig.formTextHtml) || '') } }), appConfig.forms[activeStep].fields && _jsx(Form, {}), (formConfig === null || formConfig === void 0 ? void 0 : formConfig.linkUrl) && (_jsx("div", { children: _jsx("a", __assign({ href: formConfig.linkUrl }, { children: formConfig.linkText })) }))] })) : (_jsx("div", __assign({ className: 'submit-success' }, { children: successMessage }))) }));
};
